import storage from 'redux-persist/lib/storage';

export default function () {
    return {
        key: `softpro_documents_${process.env.REACT_APP_ENV || 'production'}_root`,
        storage,
        whitelist: ['auth'],
    };
}
